import { z } from "zod";
export const claim = z.object({
  ethAddress: z
    .string({ required_error: "ETH Address is required" })
    .trim()
    .length(42, { message: "ETH Address must be 42 characters long" }),
});
